const updates = [
  {
    id: 1,
    date: '2026.07.31',
    title: '《流浪地球3》4K修复版上线',
    desc: '经典科幻巨制以更高画质回归，全新杜比音效加持，带来震撼视听体验。',
    tag: '上新',
    tagStyle: 'bg-primary-500/15 text-primary-300',
  },
  {
    id: 2,
    date: '2026.07.30',
    title: '暑期档专题「动漫嘉年华」重磅推出',
    desc: '集中更新20部热门番剧全集，从经典老番到当季新作，动漫迷不容错过。',
    tag: '专题',
    tagStyle: 'bg-accent-500/15 text-accent-300',
  },
  {
    id: 3,
    date: '2026.07.28',
    title: '播放体验全面优化升级',
    desc: '新增智能切换线路功能，播放卡顿时自动切换最优节点，观影更顺畅。',
    tag: '优化',
    tagStyle: 'bg-secondary-500/15 text-secondary-300',
  },
  {
    id: 4,
    date: '2026.07.26',
    title: '韩剧《眼泪女王》全集更新完毕',
    desc: '年度现象级韩剧现已全集上线，一次性畅享催泪大结局，追剧不再等待。',
    tag: '上新',
    tagStyle: 'bg-primary-500/15 text-primary-300',
  },
  {
    id: 5,
    date: '2026.07.24',
    title: '纪录片频道全新改版上线',
    desc: '新增BBC、国家地理等顶级纪录片频道内容，探索世界从这里开始。',
    tag: '改版',
    tagStyle: 'bg-accent-500/15 text-accent-300',
  },
  {
    id: 6,
    date: '2026.07.22',
    title: '移动端观影体验重大升级',
    desc: '全面适配折叠屏和各类平板设备，手势控制播放进度，追剧更随心。',
    tag: '升级',
    tagStyle: 'bg-secondary-500/15 text-secondary-300',
  },
  {
    id: 7,
    date: '2026.07.20',
    title: '悬疑推理专题「烧脑剧场」上线',
    desc: '精选全球高分悬疑片单，从经典推理到心理惊悚，挑战你的推理能力。',
    tag: '专题',
    tagStyle: 'bg-accent-500/15 text-accent-300',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-900">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 font-bold mb-3">
              最新动态
            </h2>
            <p className="text-sm text-foreground-400 max-w-lg mx-auto">
              爱看影院内容更新与功能升级一手掌握
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-5 top-0 bottom-0 w-px bg-background-700/50 hidden md:block"></div>

            <div className="space-y-6">
              {updates.map((item) => (
                <div key={item.id} className="relative flex gap-5">
                  <div className="hidden md:flex flex-shrink-0 w-10 items-start pt-1 justify-center">
                    <div className="w-2.5 h-2.5 rounded-full bg-primary-500/60 ring-4 ring-background-900"></div>
                  </div>

                  <div className="flex-1 bg-background-800/50 border border-background-700/30 rounded-xl p-5 hover:border-primary-500/20 transition-all duration-300 cursor-pointer">
                    <div className="flex flex-wrap items-center gap-2.5 mb-2">
                      <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${item.tagStyle}`}>
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-500">{item.date}</span>
                    </div>
                    <h3 className="text-sm text-foreground-100 font-semibold mb-1.5">{item.title}</h3>
                    <p className="text-xs text-foreground-400 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}